import { Card, Select } from '../components';
import { PageHeader } from '../layouts/PageHeader';
import { useT, type Locale } from '../i18n';
import styles from './Settings.module.css';

/**
 * Settings — workspace preferences. Currently: interface language (RU/EN),
 * applied immediately and persisted per-user in localStorage.
 */
export function SettingsPage() {
  const { t, locale, setLocale } = useT();

  return (
    <div className={styles.page}>
      <PageHeader title={t('settings.title')} description={t('settings.description')} />
      <Card>
        <h2 className={styles.sectionTitle}>{t('settings.languageSection')}</h2>
        <div className={styles.field}>
          <Select
            label={t('settings.languageLabel')}
            value={locale}
            onChange={(e) => setLocale(e.target.value as Locale)}
            helperText={t('settings.languageHelper')}
            fullWidth
            options={[
              { value: 'ru', label: t('settings.russian') },
              { value: 'en', label: t('settings.english') },
            ]}
          />
        </div>
      </Card>
    </div>
  );
}
